import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { NotificationService } from './notification.service';
import { DataTransferService } from './data-transfer.service';
import { Subscription } from 'rxjs';
import { LocalStorageService } from './local-storage.service';
import { HttpErrorResponse } from '@angular/common/http';
//import { ErrorDialogComponent } from '../common-components/error-dialog/error-dialog.component';
//import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Injectable({
    providedIn: 'root'
})
export class ErrorDialogService {
    subscription: Subscription;
    expireSubscription: Subscription;
    onceDismissed: boolean = true;
    onceDismissSubscription: Subscription;

    constructor(
        public router: Router,
        public notificationService: NotificationService,
        public dataTransferService: DataTransferService,
        private localStorageService: LocalStorageService //private modalService: NgbModal,
    ) {}

    // openDialog(data: any): void {
    //     if (this.onceDismissed !== true) return;
        
    //     this.onceDismissed = false;

    //     const status = this.extractStatus(data);
    
    //     const isReportsUrl = data?.url?.includes('purchase_orders/reports') || data?.url?.includes('purchase_orders/report_counts');

    //     const displayMsg = status == 404 && isReportsUrl ? null : this.extractMessage(data);
        
    //     const result = data?.error?.result;
    
    //     if (status === 401 || (status === 403 && result === 105)) {
    //         if(data?.error?.message == 'Please enter correct credentials'){
    //             this.notificationService.setMessage(101, 'Please enter correct credentials');
    //         }
    //         if(data?.error?.message.includes('You do not have access to the portal')){
    //             this.notificationService.setMessage(101, 'You do not have access to the portal. Please contact administrator !!! ');
    //         }
    //         this.handleUnauthorized(data?.error?.data?.logout_url);
    //         return;
    //     }
    
    //     this.notificationService.setMessage(101, displayMsg);
    
    //     setTimeout(() => {
    //         this.onceDismissed = true;
    //     }, 5000);
    // }

    openDialog(data: any): void {
        if (this.onceDismissed !== true) return;
        const status = this.extractStatus(data);
        const requestUrl = data?.url || '';
        const isSsoRequest =
            requestUrl.includes('sso/configuration') ||
            requestUrl.includes('sso/toggle_sso') ||
            requestUrl.includes('tenant_identity_providers');

        if (isSsoRequest) {
            this.onceDismissed = true;
            return;
        }
    
        // The list endpoint is the bare /frontend/v1/reports collection (not
        // /reports/reports) — matched precisely so it doesn't also catch
        // sibling paths that happen to contain "reports", like
        // reports/download_reports.
        const isReportsUrl = /\/reports(\?|$)/.test(data?.url || '') || data?.url?.includes('reports/report_counts');
        const result = data?.error?.result;
    
        if (
            requestUrl.includes('login_by_admin') &&
            status === 401
        ) {
            this.onceDismissed = true;
            return;
        }

        if (status === 401 || (status === 403 && result === 105)) {
            // Sidebar inventory counts are decorative. A failure here (e.g. brands API
            // missing on the remote env, or a transient auth blip) must not wipe the session.
            if (this.isOptionalInventoryMenuCountUrl(data?.url)) {
                return;
            }
            if(data?.error?.message == 'Please enter correct credentials'){
                this.notificationService.setMessage(101, 'Please enter correct credentials');
            }
            if(data?.error?.message?.includes('You do not have access to the portal')){
                this.notificationService.setMessage(101, 'You do not have access to the portal. Please contact administrator !!! ');
            }
            this.handleUnauthorized(data?.error?.data?.logout_url);
            return;
        }
        const errorsArray = data?.error?.data?.errors ?? data?.error?.message;
        if (Array.isArray(errorsArray) && errorsArray.length > 0) {    
            this.onceDismissed = false;
            errorsArray
                .map((e: any) => e?.msg || e?.message || e?.error || e?.errs)
                .filter(Boolean)
                .forEach((msg: string) => {
                    this.notificationService.setMessage(101, msg);
                });

            this.dismissDialog();
            return;
        }    
        this.onceDismissed = false;
        
        const displayMsg = status == 404 && isReportsUrl ? null : this.extractMessage(data);
    
        this.notificationService.setMessage(101, displayMsg);
    
        this.dismissDialog();
    }

    dismissDialog() {
        setTimeout(() => {
            this.onceDismissed = true;
        }, 5000);
    }

    extractStatus(data: unknown): number | undefined {
        if (typeof data === 'object' && data !== null && 'status' in data) {
          return (data as { status?: number }).status;
        }
        return undefined;
    }
    
    // private extractMessage(data: any): string {
    //     const errors = data?.error;
    //     if (errors?.data?.errors?.length > 0) {
    //         return errors.data.errors[0].msg;
    //     }
    //     return errors?.message || data?.statusText || 'Unknown error';
    // }
    private extractMessage(errorResponse: HttpErrorResponse): string {
        const status = errorResponse?.status;
        // Status 0 = network / CORS / API unreachable — Angular's default
        // message is "Http failure response for <url>: 0 Unknown Error".
        if (status === 0) {
            return 'Service temporarily unavailable. Please try again later.';
        }

        const err = errorResponse?.error;
        const apiMessage =
            (typeof err?.message === 'string' && err.message) ||
            (typeof err?.error === 'string' && err.error) ||
            '';

        if (apiMessage && !/^Http failure response for /i.test(apiMessage)) {
            return apiMessage;
        }

        const transportMessage = errorResponse?.message || '';
        if (
            transportMessage &&
            !/^Http failure response for /i.test(transportMessage) &&
            transportMessage !== 'Unknown Error'
        ) {
            return transportMessage;
        }

        if (
            errorResponse?.statusText &&
            errorResponse.statusText !== 'Unknown Error'
        ) {
            return errorResponse.statusText;
        }

        return 'Something went wrong';
    }
    
    private isOptionalInventoryMenuCountUrl(url?: string): boolean {
        if (!url) {
            return false;
        }
        return (
            url.includes('products/brands') ||
            url.includes('products/counts') ||
            url.includes('products/marketplace_wise_count')
        );
    }

    private handleUnauthorized(logoutUrl?: string): void {
        this.localStorageService.clear();
        if (logoutUrl) {
            window.location.href = logoutUrl;
        } else {
            this.router.navigate(['/']);
        }
    }
    
    openSubscriptionAlertDialog() {}
}